const n = {
  blue: "white",
  green: "white",
  ice: "ice-900",
  orange: "ice-900",
  purple: "white",
  red: "white",
  royal: "white",
  seafoam: "ice-900",
  teal: "ice-900",
  yellow: "ice-900"
};
function r(t, e) {
  return t === "main" ? `${e}-500` : `${e}-${e === "ice" ? "200" : "100"}`;
}
function c(t, e) {
  return t === "main" ? n[e] : `${e}-700`;
}
function u({ shade: t, color: e }) {
  const o = r(t, e), i = c(t, e);
  return { computedBgColor: o, computedTextColor: i };
}
export {
  u as default
};
//# sourceMappingURL=colorScheme.js.map
